var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReset(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 134.975,
    height: 135.059,
    viewBox: "0 0 134.975 135.059",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "time-check_1_",
    "data-name": "time-check (1)",
    transform: "translate(17.52 17.663)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_3595",
    "data-name": "Path 3595",
    d: "M59.93,17.251a4.164,4.164,0,0,0-5.888,0L30.612,40.686,19.42,29.639a4.174,4.174,0,0,0-5.975,5.829L24.87,46.711a7.812,7.812,0,0,0,5.6,2.5h.137a7.8,7.8,0,0,0,5.559-2.3L59.93,23.139a4.164,4.164,0,0,0,0-5.888Z",
    transform: "translate(45.785 7.723)",
    fill: "#C8102E"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_3596",
    "data-name": "Path 3596",
    d: "M46.179,91.434A41.639,41.639,0,1,1,91.607,49.965c0,1.278-.062,2.544-.171,3.793a4.164,4.164,0,0,0,3.777,4.534,4.118,4.118,0,0,0,4.518-3.777c.133-1.512.2-3.023.2-4.551A49.967,49.967,0,1,0,45.429,99.728h.379a4.168,4.168,0,0,0,.371-8.328Z",
    transform: "matrix(0.469, -0.883, 0.883, 0.469, -17.521, 70.574)",
    fill: "#C8102E"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReset);
export default __webpack_public_path__ + "static/media/reset.bf7adccbff375967178276a58e62da95.svg";
export { ForwardRef as ReactComponent };